
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/database",
      function () {
        return require("private-next-pages/database.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/database"])
      });
    }
  